import { StoreRegistrationInquiry } from '@/class/StoreRegistrationInquiry';
import { HTTPResponse } from '@/class/HTTPResponse';
import { fetchData } from '../../../lib/api';
import SystemAdminLayout from '../../layout/SystemAdminLayout';
import {
  adminCard,
  adminTableCell,
  adminTableHead,
  adminTableWrap,
  adminPageToolbar,
  adminSectionTitleToolbar,
  adminMutedText,
} from '../../layout/adminStyles';
import React, { useCallback, useEffect, useState } from 'react';

const formatDateTime = (value?: string | null): string => {
  if (!value) {
    return '—';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const SystemAdminStoreInquiryIndexPage = () => {
  const [inquiries, setInquiries] = useState<StoreRegistrationInquiry[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadInquiries = useCallback(async () => {
    setIsLoading(true);
    try {
      const res: HTTPResponse = await fetchData('store-registration-inquiry');
      setInquiries(Array.isArray(res.data) ? res.data : []);
    } catch (err: unknown) {
      console.error(err);
      setInquiries([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadInquiries();
  }, [loadInquiries]);

  return (
    <SystemAdminLayout>
      <div className={adminPageToolbar}>
        <h2 className={adminSectionTitleToolbar}>店舗掲載リクエスト</h2>
      </div>

      <section className={adminCard}>
        <p className={`${adminMutedText} mb-4 text-sm`}>
          公開ページから一般の方が送信した、掲載してほしい店舗のリクエスト一覧です。
        </p>

        {isLoading ? (
          <p className={adminMutedText}>読み込み中...</p>
        ) : inquiries.length === 0 ? (
          <p className={adminMutedText}>リクエストはまだありません。</p>
        ) : (
          <div className={adminTableWrap}>
            <table className="w-full border-collapse mb-2">
              <thead className={adminTableHead}>
                <tr>
                  <th className={adminTableCell}>ID</th>
                  <th className={adminTableCell}>受信日時</th>
                  <th className={adminTableCell}>都道府県</th>
                  <th className={adminTableCell}>店舗名</th>
                  <th className={adminTableCell}>店舗の電話番号</th>
                </tr>
              </thead>
              <tbody>
                {inquiries.map((inquiry) => (
                  <tr key={inquiry.id} className="hover:bg-stone-50/80">
                    <td className={adminTableCell}>{inquiry.id}</td>
                    <td className={adminTableCell}>{formatDateTime(inquiry.created_at)}</td>
                    <td className={adminTableCell}>{inquiry.pref}</td>
                    <td className={adminTableCell}>{inquiry.store_name}</td>
                    <td className={adminTableCell}>{inquiry.phone_number}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </SystemAdminLayout>
  );
};

export default SystemAdminStoreInquiryIndexPage;
